import { MarkRulerPagination } from '../../domain/model/markRuler_pagination';
import { PaginationDate } from '@/core/domain/model/pagination';
import { AxiosResponse, AxiosInstance, AxiosError } from 'axios';
import Handler from '@/core/domain/usecase/handler';

export interface FetchMarkRulerRepository {
    (pagination: PaginationDate, id: number): Promise<MarkRulerPagination>
}

const fetchMarkRulerRepository = (axios: AxiosInstance): FetchMarkRulerRepository => async (pagination: PaginationDate, id: number) => {
    try {
        const response: AxiosResponse = await axios.get(`/ruler/${id}/tracking`, {
            params: pagination,
        })

        const rulerPagination: MarkRulerPagination = response.data
        return rulerPagination
    } catch (err: any | AxiosError) {
        if (err.isAxiosError) {
            throw new Handler().trataErro(err)
        } else {
            throw err
        }
    }
}

export default fetchMarkRulerRepository